export default class UserAttributeModel {



  /**
   * constructor
   */
  constructor() {

    // 将来的に動的に取得する事になるかもしれないけど今は固定値
    this.data = [
      {id: '1', dispOrder: 2, label: '教員等指導者'  , category: 'teacher'},
      {id: '2', dispOrder: 1, label: '受験生'        , category: 'student'},
      {id: '3', dispOrder: 3, label: '高校１・２年生', category: 'student'},
      {id: '4', dispOrder: 4, label: '保護者'        , category: 'student'},
      {id: '5', dispOrder: 5, label: 'その他'        , category: 'student'},
    ];
  }



  /**
   * find all
   */
  findAll() {
    return this.data.sort((a, b) => {
      return a.dispOrder > b.dispOrder ? 1 : -1;
    });
  }



  /**
   * get attribute by id
   */
  getAttributeById(id) {
    return this.data.find(attr => {
      return attr.id === id;
    });
  }



  /**
   * get category by id
   */
  getCategoryById(id) {
    const attr = this.getAttributeById(id);
    if (attr) return attr.category;
  }

  /**
   * get label by id
   */
   getLabelById(id) {
    const attr = this.getAttributeById(id);
    if (attr) return attr.label;
  }
}



// WEBPACK FOOTER //
// ./src/js/models/UserAttributeModel.js